import Layout from 'Layout'
import ScrollUnlocker from 'components/FixScroll/ScrollUnlocker'
import { ArrowRightOutlined, LinkOutlined } from "@ant-design/icons";
import { API_URL } from 'env';
import { Tooltip } from "antd";
import { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const TeamMemberTBI = () => {
    const { id, team } = useParams<{ id: string, team: string }>();
    const { t, i18n } = useTranslation();

    const navigate = useNavigate()
    const lang = i18n.language || 'en';
    const [data, setData] = useState<any>(null);
    const [userData, setUserData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [userName, setUserName] = useState<string>('');
    const [dob, setDob] = useState<string>(''); // User's birth date
    const [today, setToday] = useState<string>('')


    const detailPage = (slug: string, id: number) => {
        navigate(`/TBI/${slug}/${id}`)
    }

    const convertDateFormat = (date: string): string => {
        return date.replace(/\//g, '-');
    };

    function getToday(): string {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const yyyy = today.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    };

    function formatDate(dateString: string) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // tháng tính từ 0
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    async function fetchUserProfile(userId: string) {
        try {
            const response = await fetch(API_URL + `/api/v1/be/user/${userId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                },
            });
            if (!response.ok) {
                throw new Error("Failed to fetch user profile");
            }
            const profileData = await response.json();

            setDob(formatDate(profileData.data.birthday));
            if (lang !== 'en') {
                setUserName(profileData.data.last_name + ' ' + profileData.data.first_name);
            }
            else {
                setUserName(profileData.data.first_name + ' ' + profileData.data.last_name);
            }
            setToday(getToday());
            return profileData.data;
        }
        catch (error) {
            console.error("Error fetching user profile:", error);
        }
    }

    async function getData() {
        if (!id || !userName || userName === '' || !dob || dob === '') return;
        try {
            const dobFormat = dob.replaceAll("-", "/");
            const res = await fetch(API_URL + '/api/v1/be/numerology/calculate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                    full_name: userName,
                    date_of_birth: dobFormat,
                    current_date: today,
                    locale: lang
                }),
            });
            if (!res.ok) {
                throw new Error("Failed to fetch numerology data");
            }
            const numerologyData = await res.json();
            if (numerologyData.success === false) {
                throw new Error("Numerology API returned an error");
            }
            setData(numerologyData.data);
            return numerologyData.data;
        }
        catch (error) {
            console.error("Error fetching numerology data:", error);
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (id) {
            fetchUserProfile(id);
        }
        console.log("ID:", id);
    }, [id]);

    useEffect(() => {
        getData();
    }, [userName, dob, today]);

    return (
        <Layout>
            <Helmet>
                <title>Team Member TBI | LUMIR</title>
                <meta name="description" content="Team Member TBI Page" />
            </Helmet>
            <ScrollUnlocker />
            <Link to={'..'}
                onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                }}
            >
                <button className="btn-back bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 px-4 rounded inline-flex gap-2 items-center mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#000000" viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"></path></svg>
                    {t('Back')}
                </button>
            </Link>
            <div className="wrap-page">
                <div className="container">
                    <div className="slit-page" style={{
                        justifyContent: 'center'
                    }}>
                        <div className="left-block">
                            <h6>{t('TBITile')}</h6>
                            <h1>
                                {t('TBIDesc1_1')} <br />
                                <span>{t('TBIDesc1_2')}</span> <br />
                                {t('TBIDesc1_3')}
                            </h1>
                            <div className="form-getdata">
                                <ul>
                                    <li>
                                        <label>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                            </svg>
                                        </label>
                                        <span>{t('TBIDesc2')}</span>
                                    </li>
                                    <li>
                                        <label>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                            </svg>
                                        </label>
                                        <span>{t('TBIDesc3')}.</span>
                                    </li>
                                    <li>
                                        <label>
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                                            </svg>
                                        </label>
                                        <span>{t('TBIDesc4')}.</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="right-block">
                            {data && dob && (
                                <Suspense fallback={<div>{t('loading')}</div>}>
                                    <>
                                        <div className="wrap-chart">
                                            <div className="first-circle">
                                                <div className="wrap-first-circle">
                                                    {data &&
                                                        <svg
                                                            viewBox="0 0 150 150"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => detailPage('RI', data.numerology_indices.maturity.number)}
                                                            className="cts-svg-hover"
                                                        >
                                                            <circle
                                                                cx={75}
                                                                cy={75}
                                                                r={74}
                                                                stroke="currentColor"
                                                                fill="transparent"
                                                                strokeWidth={2}
                                                            />
                                                            <text
                                                                x="50%"
                                                                y="54%"
                                                                textAnchor="middle"
                                                                dy=".3em"
                                                                className="cts-svg-text"
                                                                fontSize={32}
                                                            >
                                                                {data.numerology_indices.maturity.number}
                                                            </text>
                                                        </svg>
                                                    }
                                                    {/* {data && <p className="cts-text-hover" style={{ cursor: 'pointer' }} onClick={() => detailPage('maturity', data.numerology_indices.maturity.number)} onMouseEnter={() => setIsHovered(1)} onMouseLeave={() => setIsHovered(0)}>{data.numerology_indices.maturity.number}</p>} */}
                                                </div>
                                                <Tooltip title="The ability to stay strong and adapt throughout trading years.">
                                                    <p className="first-title">RI</p>
                                                </Tooltip>
                                                <div className="slit-first-circlee">
                                                    <div className="block-item">
                                                        <Tooltip title="The ability to handle drawdowns and crises.">
                                                            <p className="first-title">CMI</p>
                                                        </Tooltip>
                                                        <p className="cts-text-hover-link" style={{ cursor: 'pointer' }} onClick={() => detailPage('CMI', data.numerology_indices.balance.number)}>{data.numerology_indices.balance.number}</p>
                                                    </div>
                                                    <div className="block-item">
                                                        <Tooltip title="Rational bandwidth in decision-making: the extent to which one relies on reasoning rather than emotions or the crowd.">
                                                            <p className="first-title">ARI</p>
                                                        </Tooltip>
                                                        <p className="cts-text-hover-link" style={{ cursor: 'pointer' }} onClick={() => detailPage('ARI', data.numerology_indices.rational_thinking.number)}>{data.numerology_indices.rational_thinking.number}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="first-connect-line">
                                                <p />
                                                <p />
                                            </div>
                                            <div className="second-circle">
                                                <div className="circle-items">
                                                    <div className="avg-item">
                                                        {data &&
                                                            <svg
                                                                viewBox="0 0 150 150"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => detailPage('PPA', data.numerology_indices.life_path.number)}
                                                                className="cts-svg-hover"
                                                            >
                                                                <circle
                                                                    cx={75}
                                                                    cy={75}
                                                                    r={74}
                                                                    stroke="currentColor"
                                                                    fill="transparent"
                                                                    strokeWidth={2}
                                                                />
                                                                <text
                                                                    x="50%"
                                                                    y="54%"
                                                                    textAnchor="middle"
                                                                    dy=".3em"
                                                                    className="cts-svg-text"
                                                                    fontSize={32}
                                                                >
                                                                    {data.numerology_indices.life_path.number}
                                                                </text>
                                                            </svg>
                                                        }
                                                        {/* check */}
                                                        <Tooltip title="Orientation, trading line limits → help traders determine suitable style & strategy.">
                                                            <p>PPA</p>
                                                        </Tooltip>
                                                    </div>
                                                    <div className="special-item">
                                                        {data &&
                                                            <svg
                                                                viewBox="0 0 150 150"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => detailPage('PPAI', data.numerology_indices.link_connection.number)}
                                                                className="cts-svg-hover"
                                                            >
                                                                <circle
                                                                    cx={75}
                                                                    cy={75}
                                                                    r={74}
                                                                    stroke="currentColor"
                                                                    fill="transparent"
                                                                    strokeWidth={2}
                                                                />
                                                                <text
                                                                    x="50%"
                                                                    y="54%"
                                                                    textAnchor="middle"
                                                                    dy=".3em"
                                                                    className="cts-svg-text"
                                                                    fontSize={32}
                                                                >
                                                                    {data.numerology_indices.link_connection.number}
                                                                </text>
                                                            </svg>
                                                        }
                                                        <Tooltip title="How well the long-term path matches current core strengths → showing how sustainable the chosen trading style is.">
                                                            <p className="first-title">PPAI</p>
                                                        </Tooltip>
                                                    </div>
                                                    <div className="avg-item">
                                                        {data &&
                                                            <svg
                                                                viewBox="0 0 150 150"
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => detailPage('SPI', data.numerology_indices.life_purpose.number)}
                                                                className="cts-svg-hover"
                                                            >
                                                                <circle
                                                                    cx={75}
                                                                    cy={75}
                                                                    r={74}
                                                                    stroke="currentColor"
                                                                    fill="transparent"
                                                                    strokeWidth={2}
                                                                />
                                                                <text
                                                                    x="50%"
                                                                    y="54%"
                                                                    textAnchor="middle"
                                                                    dy=".3em"
                                                                    className="cts-svg-text"
                                                                    fontSize={32}
                                                                >
                                                                    {data.numerology_indices.life_purpose.number}
                                                                </text>
                                                            </svg>
                                                        }
                                                        <Tooltip title="Core trading abilities and style → showing where the trader has the strongest edge.">
                                                            <p className="first-title">SPI</p>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                <div className="curve-item">
                                                    <svg width="90%" height="200" viewBox="0 0 600 200">
                                                        <path d="M 0 150 A 500 500 0 0 1 600 150"
                                                            stroke="currentColor" strokeWidth="1" fill="none" />
                                                    </svg>
                                                </div>
                                                <div className="wave-item">
                                                    <svg width="100%" height="94" viewBox="0 0 400 100" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="
                M0,50 
                Q20,70 40,50
                Q65,25 90,50
                Q115,75 140,50
                Q165,25 190,50
                Q215,75 240,50
                Q265,25 290,50
                Q315,75 340,50
                Q365,25 390,50
              " stroke="currentColor" strokeWidth="1" fill="transparent" />
                                                    </svg>
                                                    <div className="infor-wave">
                                                        <div className="text-info">
                                                            <Tooltip title="Cycles of growth and challenges in a trading career.">
                                                                <p className="first-title">TCI:</p>
                                                            </Tooltip>
                                                            <Tooltip title="Measuring how hard it is to stay disciplined and behave correctly when markets change → spotting the bottlenecks to design proper challenges and coaching.">
                                                                <p className="first-title">BCI:</p>
                                                            </Tooltip>
                                                        </div>
                                                        <div className="wrap-number-info">
                                                            <div className="text-info">
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('TCI1', data.numerology_indices.milestone_phase.milestone_1.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.milestone_phase.milestone_1.number}</p>
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('BCI1', data.numerology_indices.challenge.challenge_1.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.challenge.challenge_1.number}</p>
                                                            </div>
                                                            <div className="text-info">
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('TCI2', data.numerology_indices.milestone_phase.milestone_2.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.milestone_phase.milestone_2.number}</p>
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('BCI2', data.numerology_indices.challenge.challenge_2.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.challenge.challenge_2.number}</p>
                                                            </div>
                                                            <div className="text-info">
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('TCI3', data.numerology_indices.milestone_phase.milestone_3.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.milestone_phase.milestone_3.number}</p>
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('BCI3', data.numerology_indices.challenge.challenge_3.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.challenge.challenge_3.number}</p>
                                                            </div>
                                                            <div className="text-info">
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('TCI4', data.numerology_indices.milestone_phase.milestone_4.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.milestone_phase.milestone_4.number}</p>
                                                                <p className="cts-text-hover-link" onClick={() => detailPage('BCI4', data.numerology_indices.challenge.challenge_4.number)} style={{ cursor: 'pointer' }}>{data.numerology_indices.challenge.challenge_4.number}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="info-wave-bottom">
                                                        {data.numerology_indices.age_milestones.ages.map((item: number) => (
                                                            <p key={item}>{item}</p>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="second-connect-line">
                                                <p className="first-line" />
                                                <p className="second-line" />
                                                <p className="third-line" />
                                                <p className="last-line" />
                                            </div>
                                            <div className="third-circle">
                                                <div className="wrap-circle !cursor-pointer">
                                                    {data &&
                                                        <svg
                                                            viewBox="0 0 150 150"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => detailPage('NEI', data.numerology_indices.birth_day.number)}
                                                            className="cts-svg-hover"
                                                        >
                                                            <circle
                                                                cx={75}
                                                                cy={75}
                                                                r={74}
                                                                stroke="currentColor"
                                                                fill="transparent"
                                                                strokeWidth={2}
                                                            />
                                                            <text
                                                                x="50%"
                                                                y="54%"
                                                                textAnchor="middle"
                                                                dy=".3em"
                                                                className="cts-svg-text"
                                                                fontSize={32}
                                                            >
                                                                {data.numerology_indices.birth_day.number}
                                                            </text>
                                                        </svg>
                                                    }
                                                    <Tooltip title="Natural trading edge (sharpness, intuition, reaction speed)">
                                                        <span className="first-title">NEI</span>
                                                    </Tooltip>
                                                </div>
                                                <div className="wrap-circle">
                                                    {data &&
                                                        <svg
                                                            viewBox="0 0 150 150"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => detailPage('EDI', data.numerology_indices.soul.number)}
                                                            className="cts-svg-hover"
                                                        >
                                                            <circle
                                                                cx={75}
                                                                cy={75}
                                                                r={74}
                                                                stroke="currentColor"
                                                                fill="transparent"
                                                                strokeWidth={2}
                                                            />
                                                            <text
                                                                x="50%"
                                                                y="54%"
                                                                textAnchor="middle"
                                                                dy=".3em"
                                                                className="cts-svg-text"
                                                                fontSize={32}
                                                            >
                                                                {data.numerology_indices.soul.number}
                                                            </text>
                                                        </svg>
                                                    }
                                                    <Tooltip title="Sources of motivation and the level of emotional discipline in trading.">
                                                        <span className="span-nth-second">EDI</span>
                                                    </Tooltip>
                                                </div>
                                                <div className="wrap-circle">
                                                    {data &&
                                                        <svg
                                                            viewBox="0 0 150 150"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => detailPage('MPI', data.numerology_indices.personality.number)}
                                                            className="cts-svg-hover"
                                                        >
                                                            <circle
                                                                cx={75}
                                                                cy={75}
                                                                r={74}
                                                                stroke="currentColor"
                                                                fill="transparent"
                                                                strokeWidth={2}
                                                            />
                                                            <text
                                                                x="50%"
                                                                y="54%"
                                                                textAnchor="middle"
                                                                dy=".3em"
                                                                className="cts-svg-text"
                                                                fontSize={32}
                                                            >
                                                                {data.numerology_indices.personality.number}
                                                            </text>
                                                        </svg>
                                                    }
                                                    <Tooltip title="How a trader is recognized in the market → their style and unique mark.">
                                                        <span className="first-title">MPI</span>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className="name-birth-info">
                                                {/* <p>{data.input.full_name}</p> */}
                                                <p>{userName}</p>
                                                <p>{convertDateFormat(data.input.date_of_birth)}</p>
                                            </div>
                                            <div className="wrap-half-circle">
                                                <svg width="200" className="cts-svg-hover" height="180" viewBox="0 0 200 180" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10,160 A90,90 0 0,1 190,160 L140,160 A40,40 0 0,0 60,160 Z" fill="none" stroke="currentColor" strokeWidth="3" />
                                                </svg>
                                                <Tooltip title="The burden of repeated bad habits → if not addressed, they eat away at profit expectations.">
                                                    <p>WMI</p>
                                                </Tooltip>
                                                <div className="wrap-numbers">
                                                    {data.numerology_indices.missing_aspects.map((item: any) => (
                                                        <span className="cts-text-hover-link" onClick={() => detailPage('WMI', item.number)} style={{ cursor: 'pointer' }} key={item.number}>{item.number}</span>
                                                    ))}
                                                </div>
                                            </div>
                                            <div className="third-connect-line">
                                                <p />
                                                <svg width="180" height="120" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M 10 120 Q 90 50, 180 120" stroke="currentColor" fill="none" strokeWidth="1" />
                                                </svg>
                                            </div>
                                            <div className="fourth-circle">
                                                {data && <div className="wrap-rectangle-img" style={{ cursor: 'pointer' }}>
                                                    <Tooltip title="The special strength area that helps a trader break through.">
                                                        <div className="rectangle">SAI</div>
                                                        <div className="wrap-p">
                                                            {data && data.numerology_indices.passion.map((item: any) => (
                                                                <p onClick={() => detailPage('SAI', item.number)}>{item.number}</p>
                                                            ))}
                                                        </div>
                                                    </Tooltip>
                                                </div>}
                                                <div className="wrap-circle-img">
                                                    {data &&
                                                        <svg
                                                            viewBox="0 0 150 150"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => detailPage('IOCI', data.numerology_indices.soul_personality_link.number)}
                                                            className="cts-svg-hover"
                                                        >
                                                            <circle
                                                                cx={75}
                                                                cy={75}
                                                                r={74}
                                                                stroke="currentColor"
                                                                fill="transparent"
                                                                strokeWidth={2}
                                                            />
                                                            <text
                                                                x="50%"
                                                                y="54%"
                                                                textAnchor="middle"
                                                                dy=".3em"
                                                                className="cts-svg-text"
                                                                fontSize={32}
                                                            >
                                                                {data.numerology_indices.soul_personality_link.number}
                                                            </text>
                                                        </svg>
                                                    }
                                                    <Tooltip title="The consistency between what one wants inside and what is shown outside in trading decisions → reducing inner conflict and increasing coherence.">
                                                        <span className="first-title">IOCI</span>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className="fifth-circle">
                                                <p className="line" />
                                                <div className="wrap-circle-img">
                                                    {data &&
                                                        <svg
                                                            viewBox="0 0 150 150"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => detailPage('SSI', data.numerology_indices.subconscious_strength.number)}
                                                            className="cts-svg-hover"
                                                        >
                                                            <circle
                                                                cx={75}
                                                                cy={75}
                                                                r={74}
                                                                stroke="currentColor"
                                                                fill="transparent"
                                                                strokeWidth={2}
                                                            />
                                                            <text
                                                                x="50%"
                                                                y="54%"
                                                                textAnchor="middle"
                                                                dy=".3em"
                                                                className="cts-svg-text"
                                                                fontSize={32}
                                                            >
                                                                {data.numerology_indices.subconscious_strength.number}
                                                            </text>
                                                        </svg>
                                                    }
                                                    <Tooltip title="The stability of unconscious reactions under market reversals or high pressure (the ability not to break discipline in a sudden reflex).">
                                                        <span className="first-title">SSI</span>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            {/* <div className="show-text" style={{ zIndex: 100 }}>
          <div className="part-1">
            {strengthArrows && <p onClick={() => detailPage('strength_arrows', data.numerology_indices.strength_arrows[0].number)} style={{ cursor: 'pointer' }}>TA</p>}
            {checkWeakness && <p onClick={() => detailPage('weakness_arrows', data.numerology_indices.weakness_arrows.number)} style={{ cursor: 'pointer' }}>MA</p>}
          </div>
          <div className="part-2">
            {isGeneration && <p onClick={() => detailPage('generation', data.numerology_indices.generation.number)} style={{ cursor: 'pointer' }}>CII</p>}
            {karmicDebt && <p onClick={() => detailPage('karmic_debt', data.numerology_indices.karmic_debt.number)} style={{ cursor: 'pointer' }}>BLI</p>}
            {attitude && <p onClick={() => detailPage('attitude', data.numerology_indices.attitude.number)} style={{ cursor: 'pointer' }}>TAI</p>}
            {subconsciousSelf && <p onClick={() => detailPage('subconscious_self', data.numerology_indices.subconscious_self.number)} style={{ cursor: 'pointer' }}>MRI</p>}
          </div>
        </div> */}
                                            <div className="last-part">
                                                <div className="first-col">
                                                    <p />
                                                    <p />
                                                    <p />
                                                </div>
                                                <div className="wrap-wave">
                                                    <svg viewBox="0 0 500 150">
                                                        <path d="
                M0,55
                C0,60 40,20 100,75
                S155,100 200,75
                S250,60 300,100
                S375,100 400,75
                S475,20 500,35
              "
                                                            fill="none"
                                                            stroke="currentColor"
                                                            strokeWidth="1"
                                                        />
                                                    </svg>
                                                    <div className="wrap-nuts">
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 0 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">0</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 0 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 1 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">1</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 1 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 2 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">2</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 2 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 3 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">3</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 3 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 4 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">4</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 4 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 5 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">5</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 5 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 6 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">6</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 6 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 7 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">7</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 7 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 8 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">8</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 8 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                        <div className="nut">
                                                            <p />
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 9 && <span style={{ cursor: 'pointer' }} onClick={() => detailPage('AMI', data.numerology_indices.alignment_signals.personal_year.number)} className="cts-span-hover">9</span>}
                                                            {data.numerology_indices.alignment_signals.personal_year.number === 9 &&
                                                                <label>
                                                                    <Tooltip className="!border-0" title="Big Yearly Trends & Pace – tells traders whether they are likely to “go with the flow” or have resistance over the next 12 months.">
                                                                        AMI
                                                                    </Tooltip>
                                                                </label>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="first-col">
                                                    <p />
                                                    <p />
                                                    <p />
                                                </div>
                                            </div>
                                        </div >
                                    </>
                                </Suspense>
                            )}
                            {!dob && !data && !loading &&
                                (
                                    <div className='wrap-btn-checknow'>
                                        <p>{t('TBIUpdatebirthDate')}</p>
                                        <div className="wrap-btn-search">
                                            User needs to update birth date in profile
                                        </div>
                                    </div>
                                )}
                            {
                                loading && (
                                    <div className='wrap-btn-checknow'>
                                        <p>{t('loading')}</p>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>

        </Layout>
    );

};

export default TeamMemberTBI;